import Account from 'modules/Services/Account/Account'
import Sagas from 'modules/Services/Account/saga'
import Reducer from 'modules/Services/Account/reducer'

export default Account

export { Sagas, Reducer }
